import { RequestErrorDataApi } from "../errors"
import { dataAPI } from "./api"
import { parseTabs } from "./fields"
import { extractMetaData } from "./utils/itemParsing"
import { DataApiQueryOptions, Receiver } from "./models/api/api"
import { ItemViewGroupingComponentDTO } from "./models/fields"
import { IItemDetail } from "../components/itemdetail"
import { IUserFormattingSettings } from "../components/applicationheader/components/usermenu"

export const getItemDetail = async (
    itemId: number,
    userFormattingSettings: IUserFormattingSettings,
    queryParameters?: DataApiQueryOptions,
    receiver?: Receiver,
): Promise<IItemDetail> => {
    try {
        const fullItemDetail =
            await dataAPI.getJSON<ItemViewGroupingComponentDTO>(
                `itemviews(itemid=${itemId},code='itemdetail')`,
                queryParameters,
                receiver,
            )

        const tabs = parseTabs(fullItemDetail, userFormattingSettings)
        const itemDetail = extractMetaData(
            fullItemDetail.MetaData,
            userFormattingSettings,
        )

        return {
            tabs,
            item: {
                id: fullItemDetail.Item.Id,
                number: fullItemDetail.Item.Number,
                concept: {
                    id: fullItemDetail.Item.Concept.Id,
                    label: fullItemDetail.Item.Concept.Label,
                    code: fullItemDetail.Item.Concept.Code,
                    itemType: fullItemDetail.Item.Concept.ItemType,
                },
                status: {
                    id: fullItemDetail.Item.Status.Id,
                    label: fullItemDetail.Item.Status.Label,
                    code: fullItemDetail.Item.Status.Code,
                },
            },
            ...itemDetail,
        }
    } catch (error) {
        if (error instanceof Response) {
            const errorMessage = error instanceof Error ? error.message : ""
            throw await RequestErrorDataApi.create(
                errorMessage,
                error.status,
                error,
            )
        }
        throw error
    }
}
